import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { SharedService } from 'src/service/sharedservice/shared.service.service';

export const PermissionGuard: CanActivateFn = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | UrlTree => {
  const sharedService = inject(SharedService);
  const router = inject(Router);

  const requiredSlug = route.data?.['slug'];

  if (sharedService.hasPermission(requiredSlug)) {
    return true;
  }

  const fallbackSlug = sharedService.findFirstAccessibleSlug() ?? sharedService.findDefaultTabSlug();

  if (fallbackSlug) {
    return router.parseUrl(`/${fallbackSlug}`);
  }

  return router.parseUrl('/login');
};